import React, { FC, useEffect } from 'react';
import MeridiemRadioGroup from './meridiemSelectors/meridiemRadioGroups';
import { TTimeSelectors } from '../../../types/timeField.types';
import TimeDropdownSelectors from './hoursMinuteDropdowns/timeDropdownSelector';

const TimeSelectors: FC<TTimeSelectors> = ({ fields, updateSendData, minutesInterval, hideMeridiemSelector, hourMinutesFormat }) => {
  const meridiemValues = [
    { text: 'cnhi-time-field-am', value: 'am' },
    { text: 'cnhi-time-field-pm', value: 'pm' },
  ];

  const defaultTimeValues = {
    meridiem: hideMeridiemSelector ? '' : meridiemValues[1].value,
  };

  const setInitialState = () => {
    updateSendData(defaultTimeValues);
  };

  useEffect(() => {
    if (!fields.value) {
      setInitialState();
    }
  }, [fields.value]);

  const handleTimeOptionClick = (value) => {
    updateSendData(value);
  };

  const handleMeridiemOptionClick = (value: string) => {
    updateSendData({
      meridiem: value,
    });
  };

  return (
    <>
      <div className="sitecore-jss-form__control--time-selectors-list-warper">
        <TimeDropdownSelectors
          updateSendData={handleTimeOptionClick}
          fields={fields}
          hideMeridiemSelector={hideMeridiemSelector}
          minutesInterval={minutesInterval}
          hourMinutesFormat={hourMinutesFormat}
        />
      </div>
      {!hideMeridiemSelector && (
        <MeridiemRadioGroup
          fields={fields}
          values={meridiemValues}
          handleSelectorClick={handleMeridiemOptionClick}
          defaultValue={defaultTimeValues.meridiem}
        />
      )}
    </>
  );
};

export default TimeSelectors;
